module.exports = __webpack_public_path__ + "media/images/front/programs/01-3b2d2f971019bb0e1d9ae94f6907be5d.jpg";